import React from 'react'
import { Router, Route, browserHistory } from 'react-router'
import App from './pages/App'
import InviteRecord from './pages/inviteRecord'
import PlusMyAssetDialog from './pages/PlusMyAssetDialog'
import PingAnCard from './pages/pingAnCard'
export default () => (
    <Router history={browserHistory}>
        <Route path="/cms-mobile" component={App} />
        <Route path="/activity/cms-mobile" component={App} />
        <Route path="/activity/invite-record" component={InviteRecord} />
        <Route path="/activity/plusMyAssetDialog" component={PlusMyAssetDialog} />
        <Route path="/activity/pingAnCard" component={PingAnCard} />
        <Route path="*" component={App} />
    </Router>
)
